import { useContext, useMemo } from 'react';

import { ModernHotelContext } from 'app/context/HotelContext/ModernHotelContext';
import { isPackInSetup, isPackVisibleInExtranet } from 'app/utils/extranet';

export const useFilteredPacks = (isDaytime: boolean) => {
  const { packsList, publishedRooms } = useContext(ModernHotelContext);

  const sortedNightStayPacks = useMemo(() => {
    return packsList.filter((pack) => {
      const isNightStay = !pack.isDaytime;

      const hasPublishedRoom = (pack.packRooms ?? []).some((packRoom) =>
        (publishedRooms ?? []).some((room) => room.id === packRoom.roomId)
      );

      return (
        isPackVisibleInExtranet(pack.status) && isNightStay && hasPublishedRoom
      );
    });
  }, [packsList, publishedRooms]);

  const sortedDaytimePacks = useMemo(() => {
    return packsList.filter(
      (pack) => isPackVisibleInExtranet(pack.status) && pack.isDaytime
    );
  }, [packsList]);

  // Packs still being set up are listed after the ones on sale, in their own
  // section.
  const packsBySetup = useMemo(() => {
    const packs = isDaytime ? sortedDaytimePacks : sortedNightStayPacks;

    return {
      onSalePacks: packs.filter((pack) => !isPackInSetup(pack.status)),
      setupPacks: packs.filter((pack) => isPackInSetup(pack.status)),
    };
  }, [isDaytime, sortedDaytimePacks, sortedNightStayPacks]);

  return { sortedNightStayPacks, sortedDaytimePacks, packsBySetup };
};
